var _style, _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranchPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#05D819;}\n\t.st1{fill:#178C06;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#F0F0F0;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128,2C81.2,2,43.3,39.9,43.3,86.6c0,61.7,61,105.7,81,164.8c0.6,1.8,2.1,2.6,3.6,2.6 C143.3,163.4,146.2,78.2,128,2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M128,2c46.8,0,84.7,37.9,84.7,84.6c0,61.7-61,105.7-81,164.8c-0.6,1.8-2.1,2.6-3.6,2.6L128,2L128,2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M128,22.5c-34.8,0-63,28.2-63,63s28.2,63,63,63C144.8,106.5,144.8,64.5,128,22.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M128,22.5c34.8,0,63,28.2,63,63s-28.2,63-63,63V22.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.7,112.4V75.3h5.7v37.1c0,1.6,1.3,2.9,2.9,2.9h51.4c1.6,0,2.9-1.3,2.9-2.9V75.3h5.7v37.1 c0,4.7-3.8,8.6-8.6,8.6h-51.4C97.6,121,93.7,117.1,93.7,112.4z M156.5,49.6v20l-11.4-11.4v-8.6c0-1.6,1.3-2.9,2.9-2.9h5.7 C155.3,46.8,156.5,48,156.5,49.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M124,43.9c2.2-2.2,5.8-2.2,8.1,0l38,37.9c1.1,1.1,1.1,2.9,0,4s-2.9,1.1-4,0l-37.9-38l-37.9,38 c-1.1,1.1-2.9,1.1-4,0c-1.1-1.1-1.1-2.9,0-4L124,43.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-167.5,164.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranchPin);
export default __webpack_public_path__ + "static/media/branch_pin.fdc1d925fbb5270b3c73fda1963cc043.svg";
export { ForwardRef as ReactComponent };